<script setup lang="ts">

</script>

<template>
    <div id="regulations" class="p-4 pb-8 bg-kozel-brown">
        <h1 class="text-5xl text-kozel-white text-center pb-4">Regulamin</h1>
        <a role="button" class="block leading-none text-xs w-fit text-center" href="/regulations.pdf" download>POBIERZ<br/>REGULAMIN</a>
    </div>
</template>

<style scoped>

</style>